import React from 'react';
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

interface SessionExpiredModalProps {
  open: boolean;
  onGoHome: () => void;
}

export const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({
  open,
  onGoHome
}) => {
  return (
    <Dialog
      open={open}
      onClose={onGoHome}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          sx: { borderRadius: 2 }
        }
      }}
    >
      <DialogTitle sx={{
        textAlign: 'center',
        color: 'warning.main',
        fontWeight: 600,
        pb: 1
      }}>
        ⏰ Sesión Expirada
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', py: 3 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Su sesión de registro ha expirado por inactividad.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Por seguridad, las sesiones de registro expiran después de 30 minutos de inactividad.
          Para continuar, deberá iniciar sesión o comenzar un nuevo proceso de registro.
        </Typography>
        <Box sx={{
          backgroundColor: 'warning.main',
          color: 'white',
          borderRadius: 1,
          p: 2,
          mb: 2
        }}>
          <Typography variant="body2" sx={{ fontWeight: 500, display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
            <LockIcon fontSize="small" />
            Sus datos están seguros - ninguna información personal se ha perdido permanentemente.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button
          variant="contained"
          onClick={onGoHome}
          size="large"
          sx={{
            minWidth: '200px',
            py: 1.5,
            bgcolor: (theme) => theme.palette.background.buttonBg,
            color: (theme) => theme.palette.background.buttonText,
            '&:hover': {
              bgcolor: (theme) => theme.palette.background.buttonBg,
              filter: 'brightness(0.9)',
            }
          }}
        >
          Ir al Inicio de Sesión
        </Button>
      </DialogActions>
    </Dialog>
  );
};
